import React, { useState } from 'react';
import '../index.css';

const Products = ({setFinalPro, onSubmit, isSubmit}) => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedVariation, setSelectedVariation] = useState(null);

    // Products array with variations
    const products = [
        {
            id: 1,
            title: "Mounjaro",
            description: "Mounjaro (tirzepatide) is a groundbreaking dual GIP and GLP-1 receptor agonist that helps regulate blood sugar levels and promotes weight loss by reducing appetite and slowing digestion.",
            image: `/assets/images/shop/mounjaro.png`,
            features: [
                "Proven weight loss efficacy",
                "Once-weekly injection",
                "Gradual dose escalation"
            ],
            variations: [
                { id: 'm-2.5', strength: '2.5mg', duration: '4 weeks', price: '$125' },
                { id: 'm-5', strength: '5mg', duration: '4 weeks', price: '$135' },
                { id: 'm-7.5', strength: '7.5mg', duration: '4 weeks', price: '$145' },
                { id: 'm-10', strength: '10mg', duration: '4 weeks', price: '$155' },
                { id: 'm-12.5', strength: '12.5mg', duration: '4 weeks', price: '$165' },
                { id: 'm-15', strength: '15mg', duration: '4 weeks', price: '$175' }
            ]
        },
        {
            id: 2,
            title: "Wegovy",
            description: "Wegovy (semaglutide) is a GLP-1 receptor agonist specifically approved for weight management, helping you feel fuller for longer while reducing calorie intake.",
            image: `/assets/images/shop/wegovy.jpg`,
            features: [
                "Significant weight loss results",
                "Weekly injection convenience",
                "Progressive dosing schedule"
            ],
            variations: [
                { id: 'w-0.25', strength: '0.25mg', duration: '4 weeks', price: '$115' },
                { id: 'w-0.5', strength: '0.5mg', duration: '4 weeks', price: '$125' },
                { id: 'w-1', strength: '1mg', duration: '4 weeks', price: '$135' },
                { id: 'w-1.7', strength: '1.7mg', duration: '4 weeks', price: '$145' },
                { id: 'w-2.4', strength: '2.4mg', duration: '4 weeks', price: '$155' }
            ]
        }
    ];

    const handleProductSelect = (product, variation) => {
        setSelectedProduct(product);
        setSelectedVariation(variation);
        setFinalPro(`${product?.title} - ${variation?.strength}`);
    };

    return (
        <div className="products-container">
            {/* Header Section */}
            <div className="products-header">
                <h1>Choose Your Weight Loss Treatment</h1>
                <p className="header-description">
                    Select the product and strength that best fits your weight loss journey. 
                    Each option includes a 4-week supply with gradual dose escalation for optimal results.
                </p>
            </div>

            {/* Products Grid */}
            <div className="products-grid">
                {products.map(product => (
                    <div 
                        key={product.id} 
                        className={`product-card ${selectedProduct?.id === product.id ? 'selected' : ''}`}
                    >
                        {/* Product Image */}
                        <div className="product-image">
                            <img src={product.image} alt={product.title} />
                            {/* <div className="product-badge">Recommended</div> */}
                        </div>

                        {/* Product Info */}
                        <div className="product-info">
                            <h3>{product.title}</h3>
                            <p className="product-description">{product.description}</p>
                            
                            {/* Features List */}
                            <ul className="features-list">
                                {product.features.map((feature, index) => (
                                    <li key={index}>✓ {feature}</li>
                                ))}
                            </ul>

                            {/* Variations */}
                            <div className="variations-section">
                                <h4>Select Strength:</h4>
                                <div className="variations-grid">
                                    {product.variations.map(variation => (
                                        <button
                                            key={variation.id}
                                            className={`variation-btn ${
                                                selectedProduct?.id === product.id && 
                                                selectedVariation?.id === variation.id ? 'active' : ''
                                            }`}
                                            onClick={() => handleProductSelect(product, variation)}
                                        >
                                            <div className="strength">{variation.strength}</div>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Selection Summary & Submit */}
            {selectedProduct && selectedVariation && (
                <div className="selection-summary">
                    <div className="summary-content">
                        <h3>Your Selection</h3>
                        <div className="selected-product">
                            <strong>{selectedProduct.title} {selectedVariation.strength}</strong>
                        </div>
                        <button className="submit-btn" onClick={onSubmit} disabled={isSubmit} >
                            
                            {isSubmit ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Submitting...
                                </>
                            ) : (
                                "Confirm Selection & Submit"
                            )}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Products;